module.exports = __webpack_public_path__ + "img/quote-down-circle.af1ffb31.svg";